import {
  SET_CLEARING_SYSTEMS,
  UPDATE_CURRENT_VOUCHER,
  RESET_CURRENT_VOUCHER,
} from '../mutation-types'

import { GET_MARKETS } from '../action-types'

const VOUCHER_MODEL = 70
const VOUCHER_SYSTEM = 33

const voucher = {
  namespaced: true,
  state: {
    currentVoucher: {
      espSystemId: VOUCHER_SYSTEM,
      espModelId: VOUCHER_MODEL,
      market: null,
      upload: null,
      reviewed: null,
      confirmed: null,
    },
    clearingSystems: null,
  },
  mutations: {
    [SET_CLEARING_SYSTEMS](state, payload) {
      state.clearingSystems = [...payload]
    },
    [UPDATE_CURRENT_VOUCHER](state, payload) {
      if (typeof payload === 'string') state.currentVoucher[payload] = null
      else {
        const { step, value } = payload
        state.currentVoucher[step] = value
      }
    },
    [RESET_CURRENT_VOUCHER]: (state) => {
      state.currentVoucher = {
        espSystemId: VOUCHER_SYSTEM,
        espModelId: VOUCHER_MODEL,
        market: null,
        upload: null,
        reviewed: null,
        confirmed: null,
      }
    },
  },
  actions: {
    async [GET_MARKETS]({ commit }) {
      commit(SET_CLEARING_SYSTEMS, await $.get(`${API_URL}/markets`))
    },
  },
  getters: {
    clearingSystem(state) {
      // TODO Returning 1st Clearing System
      return state.clearingSystems ? state.clearingSystems[0] : null
    },
    markets(state) {
      // TODO could take a clearingSystemId some day
      return state.clearingSystems ? state.clearingSystems[0].markets : null
    },
    isVoucherInProgress: (state) => {
      return !!state.currentVoucher.market
    },
    masterClaimId: (state) => {
      return state.currentVoucher && state.currentVoucher.upload
        ? state.currentVoucher.upload.resourceId
        : 0
    },
  },
}

export default voucher
